module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.26123",
      "conversations-internal-schema": "static-1.12611",
      "head-dlb": "static-1.4884",
      "hs-test-utils": "static-1.7882",
      "hubspot-url-utils": "static-1.4025",
      "HubStyleTokens": "static-2.11314",
      "I18n": "static-7.1598",
      "jasmine-runner": "static-1.6341",
      "quartz": "static-1.6827",
      "react": "static-7.183",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.485",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6005",
      "enviro": "static-4.416",
      "hs-promise-rejection-tracking": "static-1.5433",
      "PortalIdParser": "static-2.377",
      "raven": "static-3.5768",
      "raven-hubspot": "static-1.6075",
      "bend-plugin-trellis-migration": "static-1.3297",
      "moment": "static-3.26",
      "customer-data-email": "static-1.17795",
      "cv-backend-services": "static-1.1528",
      "hub-http": "static-1.6090",
      "immutable": "static-2.19",
      "immutable-less": "static-1.4525",
      "quartz-config": "static-1.605",
      "quartz-core": "static-1.6046",
      "transmute": "static-2.85",
      "HeadJS": "static-2.731",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.7655",
      "framer-motion": "static-1.69",
      "hs-test-utils-bend-plugin": "static-1.2993",
      "msw": "static-1.39",
      "react-redux": "static-7.69",
      "redux": "static-4.16",
      "testing-library": "static-1.149",
      "foundations-theming": "static-1.4282",
      "i18n-data": "static-1.218",
      "metrics-js": "static-1.9510",
      "moment-timezone": "static-5.80",
      "react-utils": "static-2.5241",
      "jasmine": "static-4.4197",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.63",
      "styled-components": "static-2.87",
      "UIComponents": "static-3.8261",
      "visitor-ui-component-library-icons": "static-1.5816",
      "bender-build-tools": "static-1.3025",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4523",
      "apollo-stack-hubspot": "static-3.83",
      "classnames": "static-2.10",
      "cssUtils": "static-1.763",
      "customer-data-objects": "static-1.7526",
      "customer-data-ui-utilities": "static-1.9695",
      "data-fetching-client": "static-1.9548",
      "FileManagerCore": "static-1.38639",
      "FileManagerLib": "static-1.38780",
      "foundations-assets": "static-1.4711",
      "graphql": "static-1.79",
      "hs-promise-utils": "static-1.5467",
      "hubspot-apollo-client": "static-1.4751",
      "icons": "static-2.636",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.96",
      "rpc-client-utils": "static-1.4515",
      "salesImages": "static-1.522",
      "timezone-utils": "static-2.5115",
      "ui-gdpr-components": "static-1.10219",
      "ts-schema": "static-1.3973",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.133",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.816",
      "hubspotter-http": "static-1.4546",
      "mobile-manifest-mixins": "static-1.505",
      "module-federation": "static-1.20",
      "quartz-auth": "static-1.502",
      "quartz-head": "static-1.492",
      "quartz-i18n": "static-1.502",
      "quartz-routing": "static-1.257",
      "quartz-test": "static-1.502",
      "quartz-tracking": "static-1.206",
      "quick-fetch": "static-1.3806",
      "react-rhumb": "static-1.16523",
      "ui-fonts": "static-1.576",
      "usage-tracker-container": "static-1.7198",
      "usage-tracker-core": "static-1.7058",
      "bend-plugin-foundations-components": "static-1.3924",
      "floating-ui": "static-1.53",
      "foundations-theming-specialty": "static-1.1998",
      "hs-story-utils": "static-1.9298",
      "tanstack-table": "static-1.52",
      "trellis-assets": "static-1.1416",
      "ui-images": "static-2.1122",
      "bend-plugin-foundations-theming": "static-1.2765",
      "foundations-theming-base": "static-1.3267",
      "stylex": "static-1.29",
      "HubStyle": "static-2.11622",
      "sassPrefix": "static-1.153",
      "inbound-db-properties-service-client": "static-1.3739",
      "property-translator": "static-1.5279",
      "react-dnd-compat": "static-1.4491",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.8565",
      "audio-components": "static-1.5712",
      "cropperjs": "static-1.10",
      "file-manager-components": "static-1.23140",
      "FileManagerImages": "static-1.36291",
      "foundations-components-legacy": "static-1.680",
      "immerable": "static-1.4025",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "ui-universal-auth": "static-1.8793",
      "urlinator": "static-1.4404",
      "video-components": "static-1.12807",
      "video-data-lib": "static-1.34462",
      "video-embed": "static-1.35296",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.210",
      "chirp-fetch": "static-1.1754",
      "hub-http-shared-msw-handlers": "static-1.9647",
      "hubspotter-http-shared-msw-handlers": "static-1.9645",
      "history": "static-4.47",
      "react-router-dom": "static-5.26",
      "usage-tracker-session-replay": "static-1.4894",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.20642",
      "ContentUtils": "static-1.67844",
      "copilot-toolkit": "static-1.10728",
      "sanitize": "static-1.4345",
      "sanitize-text": "static-1.8017",
      "content-assistance-lib": "static-1.7548",
      "usage-tracker": "static-1.7208",
      "ui-addon-iframeable": "static-1.8919",
      "video-components-external": "static-1.10804",
      "unified-auth-core-lib": "static-1.588",
      "content-icons-ui": "static-1.2187",
      "social-insights-client-types": "static-1.21607",
      "SharedI18nStrings": "static-1.181",
      "outpost": "static-1.4070",
      "amplitude-session-replay-browser": "static-1.57",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4680",
      "integrations-lib": "static-1.15644",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5465",
      "magpie-types": "static-1.4925",
      "simple-logging-lib": "static-1.2922",
      "superstore": "static-1.4640",
      "ui-addon-video-player": "static-1.8567",
      "ui-coaching-tips": "static-1.28135",
      "navigation-messaging": "static-1.6843",
      "content-media-composition-data-lib": "static-1.11743",
      "content-media-compositions": "static-2.15750",
      "idb-keyval": "static-1.41",
      "media-bridge-lib": "static-1.18691",
      "fsm": "static-1.3602",
      "flux-actions": "static-1.323",
      "frontend-preferences-client": "static-1.7795",
      "integrations-error-boundary-lib": "static-1.13059",
      "integrations-tracking-lib": "static-1.5463",
      "laboratory-lib": "static-3.7032",
      "native-integrations-shared-strings": "static-1.7658",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10246",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11018",
      "ui-shepherd-react": "static-3.10017",
      "reactive-lib": "static-1.596",
      "growth-onboarding-feedback-components": "static-1.6453",
      "js-cookie": "static-1.18",
      "universal-page-editor-lib": "static-1.2873",
      "foundations-components-test-utils": "static-1.5138",
      "react-dlb": "static-1.74",
      "crm-record-cards-service-types": "static-1.3510",
      "framework-data-schema-resolvers": "static-1.6746",
      "location-customization-utils-lib": "static-1.8785",
      "batch-promise": "static-1.1424",
      "conditional-properties-service-client": "static-1.3691",
      "crm-pipelines-api-client-types": "static-1.4035",
      "framework-builder-read-service-client": "static-1.3901",
      "framework-data-schema-quick-fetch": "static-1.6651",
      "inbound-db-meta-service-client": "static-1.3484",
      "multi-currency-client-types": "static-1.3583",
      "persist-promise": "static-1.3581"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.26123",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12611",
      "head-dlb": "/head-dlb/static-1.4884",
      "hs-test-utils": "/hs-test-utils/static-1.7882",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4025",
      "HubStyleTokens": "/HubStyleTokens/static-2.11314",
      "I18n": "/I18n/static-7.1598",
      "jasmine-runner": "/jasmine-runner/static-1.6341",
      "quartz": "/quartz/static-1.6827",
      "react": "/react/static-7.183",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.485",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6005",
      "enviro": "/enviro/static-4.416",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
      "PortalIdParser": "/PortalIdParser/static-2.377",
      "raven": "/raven/static-3.5768",
      "raven-hubspot": "/raven-hubspot/static-1.6075",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3297",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.17795",
      "cv-backend-services": "/cv-backend-services/static-1.1528",
      "hub-http": "/hub-http/static-1.6090",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.4525",
      "quartz-config": "/quartz-config/static-1.605",
      "quartz-core": "/quartz-core/static-1.6046",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.731",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.7655",
      "framer-motion": "/framer-motion/static-1.69",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2993",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.69",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.149",
      "foundations-theming": "/foundations-theming/static-1.4282",
      "i18n-data": "/i18n-data/static-1.218",
      "metrics-js": "/metrics-js/static-1.9510",
      "moment-timezone": "/moment-timezone/static-5.80",
      "react-utils": "/react-utils/static-2.5241",
      "jasmine": "/jasmine/static-4.4197",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.63",
      "styled-components": "/styled-components/static-2.87",
      "UIComponents": "/UIComponents/static-3.8261",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5816",
      "bender-build-tools": "/bender-build-tools/static-1.3025",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4523",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.83",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.763",
      "customer-data-objects": "/customer-data-objects/static-1.7526",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9695",
      "data-fetching-client": "/data-fetching-client/static-1.9548",
      "FileManagerCore": "/FileManagerCore/static-1.38639",
      "FileManagerLib": "/FileManagerLib/static-1.38780",
      "foundations-assets": "/foundations-assets/static-1.4711",
      "graphql": "/graphql/static-1.79",
      "hs-promise-utils": "/hs-promise-utils/static-1.5467",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4751",
      "icons": "/icons/static-2.636",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.96",
      "rpc-client-utils": "/rpc-client-utils/static-1.4515",
      "salesImages": "/salesImages/static-1.522",
      "timezone-utils": "/timezone-utils/static-2.5115",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10219",
      "ts-schema": "/ts-schema/static-1.3973",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.133",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.816",
      "hubspotter-http": "/hubspotter-http/static-1.4546",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.505",
      "module-federation": "/module-federation/static-1.20",
      "quartz-auth": "/quartz-auth/static-1.502",
      "quartz-head": "/quartz-head/static-1.492",
      "quartz-i18n": "/quartz-i18n/static-1.502",
      "quartz-routing": "/quartz-routing/static-1.257",
      "quartz-test": "/quartz-test/static-1.502",
      "quartz-tracking": "/quartz-tracking/static-1.206",
      "quick-fetch": "/quick-fetch/static-1.3806",
      "react-rhumb": "/react-rhumb/static-1.16523",
      "ui-fonts": "/ui-fonts/static-1.576",
      "usage-tracker-container": "/usage-tracker-container/static-1.7198",
      "usage-tracker-core": "/usage-tracker-core/static-1.7058",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3924",
      "floating-ui": "/floating-ui/static-1.53",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1998",
      "hs-story-utils": "/hs-story-utils/static-1.9298",
      "tanstack-table": "/tanstack-table/static-1.52",
      "trellis-assets": "/trellis-assets/static-1.1416",
      "ui-images": "/ui-images/static-2.1122",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2765",
      "foundations-theming-base": "/foundations-theming-base/static-1.3267",
      "stylex": "/stylex/static-1.29",
      "HubStyle": "/HubStyle/static-2.11622",
      "sassPrefix": "/sassPrefix/static-1.153",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3739",
      "property-translator": "/property-translator/static-1.5279",
      "react-dnd-compat": "/react-dnd-compat/static-1.4491",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8565",
      "audio-components": "/audio-components/static-1.5712",
      "cropperjs": "/cropperjs/static-1.10",
      "file-manager-components": "/file-manager-components/static-1.23140",
      "FileManagerImages": "/FileManagerImages/static-1.36291",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.680",
      "immerable": "/immerable/static-1.4025",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "ui-universal-auth": "/ui-universal-auth/static-1.8793",
      "urlinator": "/urlinator/static-1.4404",
      "video-components": "/video-components/static-1.12807",
      "video-data-lib": "/video-data-lib/static-1.34462",
      "video-embed": "/video-embed/static-1.35296",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.210",
      "chirp-fetch": "/chirp-fetch/static-1.1754",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9647",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9645",
      "history": "/history/static-4.47",
      "react-router-dom": "/react-router-dom/static-5.26",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4894",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.20642",
      "ContentUtils": "/ContentUtils/static-1.67844",
      "copilot-toolkit": "/copilot-toolkit/static-1.10728",
      "sanitize": "/sanitize/static-1.4345",
      "sanitize-text": "/sanitize-text/static-1.8017",
      "content-assistance-lib": "/content-assistance-lib/static-1.7548",
      "usage-tracker": "/usage-tracker/static-1.7208",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8919",
      "video-components-external": "/video-components-external/static-1.10804",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.588",
      "content-icons-ui": "/content-icons-ui/static-1.2187",
      "social-insights-client-types": "/social-insights-client-types/static-1.21607",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
      "outpost": "/outpost/static-1.4070",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4680",
      "integrations-lib": "/integrations-lib/static-1.15644",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5465",
      "magpie-types": "/magpie-types/static-1.4925",
      "simple-logging-lib": "/simple-logging-lib/static-1.2922",
      "superstore": "/superstore/static-1.4640",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8567",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28135",
      "navigation-messaging": "/navigation-messaging/static-1.6843",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11743",
      "content-media-compositions": "/content-media-compositions/static-2.15750",
      "idb-keyval": "/idb-keyval/static-1.41",
      "media-bridge-lib": "/media-bridge-lib/static-1.18691",
      "fsm": "/fsm/static-1.3602",
      "flux-actions": "/flux-actions/static-1.323",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7795",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13059",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5463",
      "laboratory-lib": "/laboratory-lib/static-3.7032",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7658",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10246",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11018",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10017",
      "reactive-lib": "/reactive-lib/static-1.596",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6453",
      "js-cookie": "/js-cookie/static-1.18",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2873",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5138",
      "react-dlb": "/react-dlb/static-1.74",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3510",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6746",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8785",
      "batch-promise": "/batch-promise/static-1.1424",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3691",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4035",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3901",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6651",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3484",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3583",
      "persist-promise": "/persist-promise/static-1.3581"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.26123",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};